<template>
	<div class="ce-campaign-animation-teaser">
		<div class="content-wrapper">
			<div class="campaign-animation-logo">
				<img
					src="https://www.amecke.de/files/images/Aktionen/jolly-days/jolly-days-amecke-logo.png"
					alt
				>
			</div>
			<div class="campaign-animation-container">
				<div class="campaign-animation-wrapper">
					<div class="campaign-animation-packshot animated">
						<img :src="objectdata.packshotimage" alt>
					</div>
					<div class="campaign-animation">
						<div class="campaign-animation-frame">
							<img :src="objectdata.backgroundimage" alt>
						</div>
						<div class="campaign-animation-image01">
							<img :src="objectdata.animationelementimage_1" alt>
						</div>
						<div class="campaign-animation-image02">
							<img :src="objectdata.animationelementimage_2" alt>
						</div>
						<div class="campaign-animation-image03">
							<img :src="objectdata.animationelementimage_3" alt>
						</div>
					</div>
				</div>
				<div class="campaign-animation-discount animated">
					<img :src="objectdata.discountimage" alt>
				</div>
				<div
					class="campaign-animation-text"
					v-bind:inner-html.prop="objectdata.text | replaceNbsp | replaceAmp"
				></div>
			</div>
		</div>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		mounted() {
			this.initAnimation();
		},
		methods: {
			initAnimation() {
				// animate packshot
				let elemPackshot = document.querySelector(
					".campaign-animation-packshot"
				);
				let animationNamePackshot = "fadeInRightBig";
				setTimeout(function() {
					elemPackshot.classList.add(animationNamePackshot);
				}, 800);
				// animate rabatt
				let elemRabatt = document.querySelector(
					".campaign-animation-discount"
				);
				let animationNameRabatt = "fadeInRightBig";
				setTimeout(function() {
					elemRabatt.classList.add(animationNameRabatt);
				}, 1000);
			}
		},
		composed: {
			getfullheadline() {
				return;
			}
		}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";
	@import "@/scss/_animations.scss";

	.ce-campaign-animation-teaser {
		// margin: 70px auto 0;
		// max-width: 750px;
		@include min-screen($screen-min-m) {
			// margin: 140px auto 0;
		}
	}
	.campaign-animation-container {
		position: relative;
		// margin-bottom: 110px;
		margin: 0 auto 110px auto;
		max-width: 750px;

		@include min-screen($screen-min-m) {
			// margin-bottom: 140px;
			margin: 0 auto 140px auto;
		}
		.campaign-animation-wrapper {
			display: flex;
			flex-direction: row;
			.campaign-animation {
				position: relative;
				.campaign-animation-frame,
				.campaign-animation-image01,
				.campaign-animation-image02,
				.campaign-animation-image03 {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					img {
						width: 100%;
					}
				}
				.campaign-animation-frame {
					position: relative;
					z-index: 2;
				}
			}
			.campaign-animation-packshot {
				margin-right: -20px;
				opacity: 0;
				z-index: 3;
				.win.ie11 & {
					width: 185px;
					@include min-screen($screen-min-s) {
						width: 195px;
					}
					@include min-screen($screen-min-m) {
						width: 205px;
					}
				}

				@include min-screen($screen-min-m) {
					margin-right: -40px;
				}
			}
		}

		.campaign-animation-discount {
			opacity: 0;
			max-width: 175px;
			position: absolute;
			right: 37px;
			bottom: -45px;
			z-index: 4;
			@include min-screen($screen-min-m) {
				max-width: 295px;
				right: 60px;
				bottom: -90px;
			}
		}
		.campaign-animation-text {
			bottom: -85px;
			position: absolute;
			text-align: center;
			width: 100%;
			p {
				margin: 0;
			}
			@include min-screen($screen-min-m) {
				width: 370px;
				left: 0;
				text-align: left;
				bottom: -45px;
				padding-left: 15px;
			}
		}
	}

	.campaign-animation-logo {
		margin: 0 auto 30px;
		max-width: 175px;
		@include min-screen($screen-min-m) {
			display: none;
		}
	}

	/*animation*/
	.campaign-animation-image01 {
		animation: fade 8s infinite;
	}
	.campaign-animation-image02 {
		animation: fade2 8s infinite;
	}
	.campaign-animation-image03 {
		animation: fade3 8s infinite;
	}
	@keyframes fade {
		0% {
			opacity: 1;
		}
		33.333% {
			opacity: 0;
		}
		66.666% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	@keyframes fade2 {
		0% {
			opacity: 0;
		}
		33.333% {
			opacity: 1;
		}
		66.666% {
			opacity: 0;
		}
		100% {
			opacity: 0;
		}
	}
	@keyframes fade3 {
		0% {
			opacity: 0;
		}
		33.333% {
			opacity: 0;
		}
		66.666% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
</style>